
import React from 'react';

//MUI components
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';

// Redux tools and selectors
import { useSelector, useDispatch } from "react-redux";
import { periodHeuresSlice } from "../../../../store/periodSlice.js";
import { getRidingPeriod } from "../../../../store/selectors.js";
import dayjs from 'dayjs';

//Translate utils :
import { translator } from "../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)


//this component manage 1 select at a time
// props : horaire is 1 object with am and pm hours, closed or not
// props : index set which select (depart or return time)
function ListHoraires({ horaires, index }) { // destructuration à la déclaration : cover image, title of the house, id of house in database

  const dispatch = useDispatch();
  function handleChangeHeure(event) { // when time is changed
    let h = event.target.value; //value is the time as integer (ex : 17h00 -> 17)
    dispatch(periodHeuresSlice.actions.setHeure({ heure: +h, index: index })); //apply new value (time) to global state 
  };


  const lang = useSelector(getLang) //global state : language
  let ridingPeriod = useSelector(getRidingPeriod); //array of 2 arrays (2 dates,2 times)
  let heure = ridingPeriod[1][index - 1]; // get the correct time (based on index prop)


  //convert datas from object 'horaires' (prop)
  const ouverture = horaires.am_start;
  const pauseDebut = horaires.am_end;
  const pauseFin = horaires.pm_start;
  const fermeture = horaires.pm_end;
  const delta = pauseFin - pauseDebut;
  const ferme = (horaires.ferme === true); //is it closed today?

  let liste = []; // we prepare the list of select item
  if (ferme) {
    liste.push({ value: 0, text: " --- " })
  }
  else {
    if (pauseDebut !== pauseFin) { // if shop close for lunch

      if (delta > 1) {
        for (let h = ouverture; h <= pauseDebut; h++) {
          liste.push({ value: h, text: h + ":00" });
        }

        for (let h = pauseFin; h <= fermeture; h++) {
          liste.push({ value: h, text: h + ":00" });
        }
      }
    } else { //journée continue
      for (let h = ouverture; h <= fermeture; h++) {
        liste.push({ value: h, text: h + ":00" });
      }
    }

  }

  const checkValidHour = (heureLigne) => { //function to disable hours in select when date1 == date2, and we dont want start hour bigger than return hour
    //verify date1 == date2
    if (dayjs(ridingPeriod[0][0]).isSame(dayjs(ridingPeriod[0][1]))) { //same day
      if (index === 1) { //list hours of start
        return (heureLigne >= ridingPeriod[1][1]) // return TRUE (disable) when the hour of the line is bigger or equal than return hour (stored in Global state (ridingPeriod))
      }
      else {
        return (heureLigne <= ridingPeriod[1][0]) // return TRUE (disable) when the hour of the line is less or equal than start hour (stored in Global state (ridingPeriod))

      }

    }
    else { //different days
      return false;
    }
  }

  return (

    <FormControl>
      <InputLabel id="demo-simple-select-label">{translator("Heure", lang, "heureSelectLabel")}</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select1"
        value={heure}
        label={translator("Heure", lang, "heureSelectLabel")}
        disabled={(heure === 0)}
        onChange={handleChangeHeure}
        className='time-selecter'
      >
        { // add every object of the time list, to the select component
          liste.map((ligne) => <MenuItem key={ligne.value} value={ligne.value} disabled={checkValidHour(ligne.value)}>{ligne.text}</MenuItem>)
        }
      </Select>
    </FormControl>




  )
}



export default ListHoraires
